import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlConfigContainer } from '../../core/url-config';
import { UrlConfigService } from '@hrra/core';
import { AjaxDataServiceService } from '@admin/core/ajax-data-service.service';
import { LocationsViewModel } from '../models/locaions-model';

@Injectable({
  providedIn: 'root',
})
export abstract class LocationService {
  public getLocations(
    locationParentIds: string[] = []
  ): Observable<LocationsViewModel[]> {
    return <Observable<LocationsViewModel[]>>(
      this.ajax
        .postDataPaging(
          this.urlService.urlConfig.api.data.jobseeker.getLocations,
          { parentLocationIds: locationParentIds },
          LocationsViewModel
        )
        .pipe(map((r) => r.items))
    );
  }

  constructor(
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {}
}

export interface LocationsParameters {}
